/* globals cpac, $j */

if (typeof cpac !== 'undefined') {
  cpac.tabs = {
    onclick: function (aObj, value, contentId, contentClass) {
      try {
      $j('.'+contentClass).css({'display': 'none'});
      $j('#'+contentId).css({'display': 'block'});
      var div = $j(aObj).parent().parent();
      div.children('li').removeClass('selected');
      $j(aObj).parent().addClass('selected');
      div.children('input').val(value);
      aObj.blur();
      } catch(e) {
      cpac.error(e);
      }
    }
  }

  cpac.tabsCa2 = {
    onclick: function (aObj, value, contentId, contentClass) {
      try {
      $j('.'+contentClass).css({'display': 'none'});
      $j('#'+contentId).css({'display': 'block'});
      var div = $j(aObj).parent().parent();
      div.children('li').removeClass('active');
      $j(aObj).parent().addClass('active');
      div.children('input').val(value);
      aObj.blur();
      } catch(e) {
      cpac.error(e);
      }
    }
  }
}